import { Alert, Button } from 'react-bootstrap';
import { useText } from '../context/TextContext';
import useServiceWorkerUpdate from '../hooks/useServiceWorkerUpdate';

const UpdateBanner = () => {
    const { updateAvailable, applyUpdate } = useServiceWorkerUpdate();
    const texts = useText();

    if (!updateAvailable) {
        return null;
    }

    return <Alert
        variant='dark'
        className='position-fixed top-0 start-50 translate-middle-x mt-2 d-flex align-items-center gap-3 py-2 shadow'
        style={{ zIndex: 1100 }}
    >
        <span>{texts.newVersionAvailable}</span>
        <Button size='sm' variant='light' onClick={applyUpdate}>{texts.reload}</Button>
    </Alert>
}

export default UpdateBanner;
